const vueInst = new Vue({
	el: '#vue-wrap',
	data: {
		loadingFlag: false,
		cityShowFlag: false,
		cityList: [],
		info: {
			phone: '',
			nickname: '',
			name: '',
			province_id: '',
		},
		form: {
			nickname: '',
			name: '',
			province: '',
			province_id: '',
		},
	},
	computed: {
		changedFlag() {
			return this.info.nickname != this.form.nickname
				|| this.info.name != this.form.name
				|| this.info.province_id != this.form.province_id;
		}
	},
	methods: {
		getInfo(callback) {
			axios.post(baseURL + 'checkCookies')
				.then(res => {
					if (res.code == 200) {
						this.info.phone = res.list.phone;
						this.info.nickname = this.form.nickname = res.list.nickname || '';
						this.info.name = this.form.name = res.list.name || '';
						this.info.province_id = this.form.province_id = res.list.province_id;
						if (typeof callback == 'function') {
							callback();
						}
					}
					if (res.code == -1) {
						this.goLogin();
					}
				})
				.catch(err => console.log(err));
		},
		// 获取地区
		getCityList() {
			axios.post(baseURL + 'getPros')
				.then(res => {
					if (res.code == 200) {
						res.list.forEach(item => {
							if (item.id == this.form.province_id) {
								this.form.province = item.province_name;
								item.isActive = true;
							} else {
								item.isActive = false;
							}
						});
						this.cityList = res.list;
					}
				})
				.catch(err => console.log(err));
		},
		// 选择地区
		selectCity(city) {
			this.cityList.forEach(item => {
				item.isActive = false;
			});
			city.isActive = true;
			this.form.province = city.province_name;
			this.form.province_id = city.id;
		},
		// 确定修改
		submitInfo() {
			if (this.loadingFlag) {
				return;
			}
			if (this.changedFlag) {
				this.loadingFlag = true;
				axios.post(baseURL + 'updateAppUser?nickname=' + this.form.nickname + '&name=' + this.form.name + '&pid=' + this.form.province_id)
					.then(res => {
						this.loadingFlag = false;
						if (res.code == 200) {
							alert('修改成功!');
						}
					})
					.catch(err => console.log(err));
			}
		},
		// 退出
		logout() {
			axios.post(baseURL + 'loginout')
				.then(res => {
					if (res.code == 200) {
						localStorage.psw = '';
						location.href = 'index.html';
					}
				})
				.catch(err => console.log(err));
		}
	},
	created() {
		this.getInfo(
			this.getCityList
		);
	}
});